<template>
  <nav class="header-nav" :class="classes">
    <TheHeaderNavItem
      v-for="(item, index) in items"
      :key="index"
      :to="item.to"
      :exact="item.exact"
      :icon="item.icon"
      :mobile="mobile"
    >
      {{ item.name }}
    </TheHeaderNavItem>
  </nav>
</template>

<script>
import TheHeaderNavItem from "./TheHeaderNavItem";

export default {
  name: "TheHeaderNav",
  components: {
    TheHeaderNavItem
  },
  props: {
    items: Array,
    mobile: Boolean
  },
  computed: {
    classes() {
      return {
        "header-nav_mobile": this.mobile
      };
    }
  }
};
</script>

<style lang="scss">
.header-nav {
  display: flex;
  height: 32px;
  margin-top: 7px;
  justify-content: space-between;
  border-bottom: 1px solid #a0aab4;

  &_mobile {
    flex-direction: column;
    border-bottom: none;
  }
}
</style>
